import React, { FC } from 'react';
import { QuizQuestion } from '../../shared/types';
import { AutoResizableInput } from '../autoResizableInput/autoResizableInput';

type Props = {
  data: QuizQuestion;
  isSubmitted: boolean;
  currentAnswer: string;
  setCurrentAnswer: (val: string) => void;
};

export const CardTemplate2: FC<Props> = ({ data, isSubmitted, currentAnswer, setCurrentAnswer }) => {
  const splittedQuestion = data.qs_dsc?.split('*');

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentAnswer(e.target.value);
  };

  return (
    <div className="text-center">
      <h4 className="h3 tw-underline">{data.qs_main}</h4>
      <div className="mt-5 tw-flex tw-justify-center tw-items-center tw-flex-wrap gap-2">
        <p className="tw-text-xl sm:tw-text-2xl mb-0">{splittedQuestion?.[0]}</p>
        <AutoResizableInput
          disabled={isSubmitted}
          spellCheck={false}
          className={`tw-h-[38px] text-center tw-text-xl sm:tw-text-2xl border border-1 border-gray bg-white rounded-1 px-2 py-1 ${!isSubmitted ? 'hover:!tw-border-sky-500' : ''}`}
          value={currentAnswer}
          onChange={handleChange}
        />
        <p className="tw-text-xl sm:tw-text-2xl mb-0">{splittedQuestion?.[1]}</p>
      </div>

      <div
        className="btn-group tw-w-full my-4 my-sm-5 tw-flex tw-justify-center tw-flex-col min-[400px]:tw-flex-row gap-3"
        role="group"
        aria-label="Basic radio toggle button group"
      >
        {Object.values(data.paramjs).map((answ) => {
          const isAnswerCorrect = answ.correct === 'true';
          return (
            <div
              className={
                `rounded-1 py-1 px-3 tw-text-xl sm:tw-text-2xl mb-0 ${!isSubmitted ? 'tw-cursor-pointer hover:tw-scale-[1.1] tw-transition-all' : ''} ` +
                (isSubmitted && answ.value === currentAnswer
                  ? isAnswerCorrect
                    ? 'bg-success border-0 text-white'
                    : 'bg-danger text-white border-0'
                  : `border border-1 ${answ.value === currentAnswer ? '!tw-bg-[#0c276c] !tw-text-white border-[#0c276c]' : 'border-gray bg-white'} tw-text-[#0c276c]`)
              }
              onClick={() => {
                if (!isSubmitted) {
                  setCurrentAnswer(answ.value);
                }
              }}
            >
              {answ.value}
            </div>
          );
        })}
      </div>
    </div>
  );
};
